<script lang="ts">
	import { PortableText } from '@portabletext/svelte';

	import RawInternalLink from './RawInternalLink.svelte';
	import SanityInternalLink from './SanityInternalLink.svelte';
	import ExternalLink from './ExternalLink.svelte';
	import SoundCloud from './SoundCloud.svelte';
	import YouTube from './YouTube.svelte';
	import Break from './Break.svelte';
	import TextImage from './TextImage.svelte';

	interface Props {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		value: any;
	}

	let { value }: Props = $props();
</script>

<PortableText
	{value}
	components={{
		types: {
			// @ts-expect-error Error due to mixing Svelte 5 and 4 components
			soundcloud: SoundCloud,
			// @ts-expect-error Error due to mixing Svelte 5 and 4 components
			youtube: YouTube,
			break: Break,
			// @ts-expect-error Error due to mixing Svelte 5 and 4 components
			image: TextImage
		},
		marks: {
			// @ts-expect-error Error due to mixing Svelte 5 and 4 components
			internalLink: SanityInternalLink,
			// @ts-expect-error Error due to mixing Svelte 5 and 4 components
			rawInternalLink: RawInternalLink,
			// @ts-expect-error Error due to mixing Svelte 5 and 4 components
			link: ExternalLink
		}
	}}
/>
